import { Box } from '@mui/material';
import { LEVEL_TONE } from '../utils/constants';

/** A small count in a level's colour, e.g. "2 overloaded" in a calendar day. */
export default function CountChip({ level, children }) {
  return (
    <Box
      component="span"
      sx={{ display: 'inline-block', borderRadius: 1, px: 0.75, py: 0.125, fontSize: 10.5, fontWeight: 700, bgcolor: LEVEL_TONE[level].bg, color: LEVEL_TONE[level].text, whiteSpace: 'nowrap' }}
    >
      {children}
    </Box>
  );
}
